
            const data = {"name":"x-circleRed","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"M8 14.667A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333ZM10 6l-4 4M6 6l4 4\" _stroke=\"#AF4C45\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#AF4C45"}],"stopColors":[]}}
        
                    module.exports = data
                    